var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconPheasant = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.711 7.121a.377.377 0 0 1 .346-.55H23l-.629-1.005A1.194 1.194 0 0 0 21.43 5h-.598c-.282 0-.554.1-.77.283l-1.1.801h.645l-.613 2.012L1 20.227h1.037l12.65-7.04 2.53 1.194v1.572l-.408.518h2.404a.503.503 0 0 0-.503-.518h-.974V14.38l2.2-.942a4.149 4.149 0 0 0 2.121-5.595l-.346-.723z",
    fill: "#1A202C",
    fillRule: "nonzero"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPheasant, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-pheasant.caeac04c.svg";
export { ForwardRef as ReactComponent };